import style from '../scss/body.module.scss';
import Summary from '@/components/summary';
import { PoweredBy } from 'topwrite';
import { useSidebar } from '@/lib/use-sidebar';
import classNames from 'classnames';

export default function Sidebar() {

    const { setOpen, open } = useSidebar();

    return <>
        <div className={classNames(style.sidebar, {
            [style.open]: open
        })}>
            <div className={style.content}>
                <Summary />
                <PoweredBy className={style.copyright} />
            </div>
        </div>
        {open && <div onClick={() => setOpen(false)} className={style.mask} />}
    </>;
}
